import { Injectable } from "@angular/core";
import { ApiResourceService } from "@onsip/common/services/api/resources/api-resource.service";
import { ApiSessionService } from "@onsip/common/services/api/api-session.service";
import { ApiStateStoreService } from "@onsip/common/services/api/api-state-store.service";
import {
  ApiPromiseState,
  ApiPromiseStateService
} from "@onsip/common/services/api/api-promise-state.service";
import {
  VmManager,
  apiApiPbxSettingsVmManagerToPbxSettingsVmManager as clean,
  ApiPbxSettingsVmManager
} from "./vm-manager";
import { OnsipApiResponse } from "../../apiResponse/response-body";
import { getApiActionName } from "@onsip/common/services/api/onsip-api-action-new";
import { ApiBrowseAction, ApiEditAction } from "@onsip/common/services/api/api-actions";
import { arrayToRecord } from "@onsip/common/services/api/util/arrayToRecord";
import { extractData } from "@onsip/common/services/api/apiResponse/response-body-new";
import { sessionId } from "@onsip/common/services/api/apiParams/session-id";
import { organizationId } from "@onsip/common/services/api/apiParams/organization-id";
import { domain } from "@onsip/common/services/api/apiParams/domain";

const debug = false;

@Injectable({ providedIn: "root" })
export class VoicemailManagementService extends ApiResourceService<VmManager> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "VoicemailManagementAddress", "addressId");
    debug && this.state.subscribe(state => console.warn("VoicemailManagementAddress.state", state));
  }

  voicemailManagementAddressBrowse(): ApiPromiseState<VmManager> {
    this.dispatcher.next({
      parameters: {
        Action: ApiBrowseAction.VoicemailManagementAddressBrowse,
        SessionId: this.store.state.pipe(sessionId()),
        OrganizationId: this.store.state.pipe(organizationId()),
        Domain: this.store.state.pipe(domain())
      }
    });
    return this.promiseState.toPromise(ApiBrowseAction.VoicemailManagementAddressBrowse);
  }

  voicemailManagementAddressEdit(params: {
    Username: string;
    Address: string;
  }): ApiPromiseState<VmManager> {
    this.dispatcher.next({
      parameters: {
        Action: ApiEditAction.VoicemailManagementAddressEdit,
        SessionId: this.store.state.pipe(sessionId()),
        OrganizationId: this.store.state.pipe(organizationId()),
        Domain: this.store.state.pipe(domain()),
        ...params
      }
    });
    return this.promiseState.toPromise(ApiEditAction.VoicemailManagementAddressEdit);
  }

  reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    switch (action) {
      case ApiBrowseAction.VoicemailManagementAddressBrowse:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            [
              clean(
                extractData<Array<ApiPbxSettingsVmManager>>(
                  response,
                  action,
                  "VoicemailManagementAddress",
                  "VoicemailManagementAddresses"
                )
              )
            ],
            this.indexKeyName
          ),
          action
        );
        break;
      case ApiEditAction.VoicemailManagementAddressEdit:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            [
              clean([
                extractData<ApiPbxSettingsVmManager>(response, action, "VoicemailManagementAddress")
              ])
            ],
            this.indexKeyName
          ),
          action
        );
        break;
    }
  }
}
